import { PageEndpointEnum } from "../enums/endpoints";

// Mapping of restricted emails to their allowed page endpoints
// If an email is not in this map, they have full access to all pages
const RESTRICTED_USER_PERMISSIONS: Record<string, PageEndpointEnum[]> = {
  // "ivy@ribbon.finance": [PageEndpointEnum.MM_MONITORING, PageEndpointEnum.MM_CONTROL_PANEL],
};

/**
 * Returns the allowed pages for a given email, or null if the user has full access
 * @param email - The user's email address
 * @returns Array of allowed page endpoints, or null if user has full access
 */
export const getAllowedPages = (email?: string): PageEndpointEnum[] | null => {
  if (!email) {
    return null; // No email means full access (for backwards compatibility)
  }

  const allowedPages = RESTRICTED_USER_PERMISSIONS[email];
  if (allowedPages) {
    return allowedPages;
  }

  // User not in restricted list = full access
  return null;
};

/**
 * Checks if a user has access to a specific page
 * @param email - The user's email address
 * @param page - The page endpoint to check
 * @returns true if user has access, false otherwise
 */
export const hasPageAccess = (email: string | undefined, page: PageEndpointEnum): boolean => {
  const allowedPages = getAllowedPages(email);
  if (allowedPages === null) {
    return true; // Full access
  }
  return allowedPages.includes(page);
};

/**
 * Returns the default page for a user (first allowed page if restricted, otherwise dashboard)
 * @param email - The user's email address
 * @returns The default page endpoint for the user
 */
export const getDefaultPage = (email?: string): PageEndpointEnum => {
  const allowedPages = getAllowedPages(email);
  if (allowedPages === null || allowedPages.length === 0) {
    return PageEndpointEnum.DASHBOARD; // Full access users go to dashboard
  }
  return allowedPages[0]; // Restricted users go to their first allowed page
};
